var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94092 7.33321C6.94092 4.80191 8.99295 2.74988 11.5243 2.74988C14.0555 2.74988 16.1076 4.80191 16.1076 7.33321V10.0832C16.1076 12.6145 14.0555 14.6665 11.5243 14.6665C8.99295 14.6665 6.94092 12.6145 6.94092 10.0832V7.33321Z",
    stroke: "#313131",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4409 7.33325H16.1076",
    stroke: "#313131",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4409 10.0833H16.1076",
    stroke: "#313131",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8576 9.1665V10.0832C18.8576 14.1333 15.5744 17.4165 11.5243 17.4165C7.47416 17.4165 4.19092 14.1333 4.19092 10.0832V9.1665",
    stroke: "#313131",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5244 17.4165V20.1665",
    stroke: "#313131",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophone);
export default __webpack_public_path__ + "static/media/icon-microphone.fd6c3c90a44038656379c02977296071.svg";
export { ForwardRef as ReactComponent };